module.exports = function(video) {
	'use strict'
	video.directive('relatedVideoBoxDir',relatedVideoBoxDir);
	relatedVideoBoxDir.$inject=[];
	function relatedVideoBoxDir() {
		return {
			template: require('./partial/relatedVideoBox.html'),
			controller:"relatedVideoBoxController",
			controllerAs:"vmrvb",
			link: function(scope, element, attrs, ctrl) {
				    
			}
		}
	}
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/videoModule/related-video-box/js/directive/relatedVideoBoxDirective.js
// module id = 647
// module chunks = 0